import(/* webpackMode: "eager" */ "/Users/alextotalwin/Next Robot AI — Вологда/src/app/error.tsx");
